<app-topnav></app-topnav>
<!-- HEADER -->
<app-header-secondary-h [pageTitle]="'Service de garde'" 
    [pageDescription]="['Gérer par le numérique, pour donner', 'un visage plus humain au service de garde']"
    [imageURL]="'assets/img/logiciels/SDG_top.png'" *ngIf="currentLang ==='fr'"></app-header-secondary-h>
<app-header-secondary-h [pageTitle]="'Childcare service'" 
    [pageDescription]="['Digital management that can give', 'child care a more human face ']"
    [imageURL]="'assets/img/logiciels/SDG_top.png'" *ngIf="currentLang ==='en'"></app-header-secondary-h>
<!-- end HEADER -->

<!-- SECTION characteristics -->
<section id="section-characteristics">
    <div id="section-characteristics-inner">
        <div class="container">
            <div class="row">
                <div class="col col-12" *ngIf="currentLang ==='fr'">
                    <h2 class="section-title">
                        <strong>Caractéristiques et avantages</strong>
                    </h2>
                    <p>Comme un nombre important d’élèves, de parents et de membres du personnel gravitent autour du service de garde de votre établissement, voir à sa gestion peut être particulièrement complexe. Le Pluriportail et ses nombreuses options vous offrent des solutions complètes pour faciliter la communication, la prise de présences et la facturation, tout en rehaussant la sécurité des élèves et des processus.</p>
                    <p>Plurilogic innove encore avec son application mobile comprenant le module Service de garde pour améliorer le quotidien chargé des parents et permettre la conciliation travail-famille-école. Découvrez tous les avantages de ce module très complet.</p>
                </div>
                <div class="col col-12" *ngIf="currentLang ==='en'">
                    <h2 class="section-title">
                        <strong>Benefits and key features</strong>
                    </h2>
                    <p>A significant number of students, parents and non-teaching staff members are gravitating around your school’s child care service, and working on its management can be particularly demanding. With its several options, the Pluriportail proposes comprehensive solutions to facilitate communications, attendance taking, billing, as well as to increase the children’s safety.</p>
                    <p>Plurilogic is still innovating with its mobile application, including the child care service module, to improve the parents’ busy agenda and favour work-family-school balance. Discover all the benefits of this comprehensive module.</p>
                </div>
            </div>

            <div class="row">
                <div class="col col-12 col-md-6">
                    <div class="row">
                        <div class="col-md-6">
                            <img src="assets/img/pages/characteristics_01.svg" />
                        </div>
                        <div class="col-md-6">
                            <div class="content">
                                <p *ngIf="currentLang ==='fr'">Envoi d’un signal pour annoncer l’arrivée imminente du parent au service de garde.</p>
                                <p *ngIf="currentLang ==='en'">Sending a signal to announce the imminent arrival of the parent at the child care service.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col col-12 col-md-6">
                    <div class="row">
                        <div class="col-md-6">
                            <img src="assets/img/pages/characteristics_02.svg" />
                        </div>
                        <div class="col-md-6">
                            <div class="content">
                                <p *ngIf="currentLang ==='fr'">Comptabilisation des entrées et sorties des élèves pour une facturation juste et équitable.</p>
                                <p *ngIf="currentLang ==='en'">Accounting of entry and exit of the students, for a fair and equitable billing</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col col-12 col-md-6">
                    <div class="row">
                        <div class="col-md-6">
                            <img src="assets/img/pages/characteristics_03.svg" />
                        </div>
                        <div class="col-md-6">
                            <div class="content">
                                <p *ngIf="currentLang ==='fr'">Création d’une structure stable grâce à l’administration synchronisée avec les logiciels de gestion pédagogique (FGP), financière (FGF) et le Pluriportail.</p>
                                <p *ngIf="currentLang ==='en'">Creation of a stable structure thanks to administration procedures that are synchronized with pedagogical (FGP) and financial (FGF) management software and the Pluriportail.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col col-12 col-md-6">
                    <div class="row">
                        <div class="col-md-6">
                            <img src="assets/img/pages/characteristics_04.svg" />
                        </div>
                        <div class="col-md-6">
                            <div class="content">
                                <p *ngIf="currentLang ==='fr'">Prise de présences numérisée pour une gestion améliorée et une sécurité accrue.</p>
                                <p *ngIf="currentLang ==='en'">Digitalized attendance taking for improved management and increased security.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
<!-- end SECTION characteristics -->


<!-- SECTION - taquets -->
<app-taquets *ngIf="currentLang ==='fr'" #ref [title]="taquets.title" [description]="taquets.description" [items]="taquets.items">
    <div class="taquets-slides">
        <div class="taquets-slide" [class.active]="ref.selected === 0">

            <h2 class="section-title"><strong>Sécurité</strong></h2>
            <p>En numérisant toute l’information concernant les allées et venues d’un élève et de ses répondants, vous obtenez un portrait exhaustif de la situation. Il est possible de gérer également les personnes qui ont la permission de venir chercher un élève sporadiquement. Enfin, en mettant l’horaire des élèves à la disposition des intervenants, il devient plus facile pour eux de les surveiller et de les localiser.</p>
                    
        </div>
        <div class="taquets-slide" [class.active]="ref.selected === 1">

            <h2 class="section-title"><strong>Communication</strong></h2>
            <p>Réduisez de 90% l’usage du walkie-talkie afin que les éducateurs soient moins sollicités, donc mieux concentrés pour veiller à l’organisation des groupes. Aussi, l’intégration des activités parascolaires au service de garde, la géolocalisation des parents, les départs hâtifs et les autres fonctionnalités améliorent grandement la communication entre chacune des parties.</p>

        </div>
        <div class="taquets-slide" [class.active]="ref.selected === 2">

            <h2 class="section-title"><strong>Dossier des élèves</strong></h2>
            <p>Tenir un journal de bord dans le Pluriportail permet de mieux gérer les comportements des élèves. Avoir la fiche santé de chacun d’eux à portée de main fournit aux éducateurs toutes les informations pertinentes à leur bien-être, comme les allergies et la médication.</p>

        </div>
        <div class="taquets-slide" [class.active]="ref.selected === 3">

            <h2 class="section-title"><strong>Finances</strong></h2>
            <p>Plurilogic sait combien il peut être exigeant d’offrir un service financier irréprochable à chacun des utilisateurs d’un service de garde. La gestion intégrée des finances, la production des Relevés 24 et la diminution des risques d’erreurs pour les paiements sporadiques sont des avantages dont vous pouvez profiter avec ce module.</p>

        </div>
        
    </div>
</app-taquets>
<app-taquets *ngIf="currentLang ==='en'" #ref [title]="taquets.titleEN" [description]="taquets.descriptionEN" [items]="taquets.itemsEN">
    <div class="taquets-slides">
        <div class="taquets-slide" [class.active]="ref.selected === 0">

            <h2 class="section-title"><strong>Security</strong></h2>
            <p>By digitalizing all information in relation with the monitoring of the comings and goings of a student and of the persons in charge of this student, you get the complete picture of the situation. In the same manner, it is possible to supervise the persons who are allowed to occasionally pick the child up at school. Finally, by providing the interveners with the students’ schedules, it is easier for them to precisely locate and supervise the children.</p>
                    
        </div>
        <div class="taquets-slide" [class.active]="ref.selected === 1">

            <h2 class="section-title"><strong>Communications</strong></h2>
            <p>By reducing by 90% the use of walkie-talkies, the teachers have less work and are more focused. This also allows them to ensure optimal group organization. As well, by integrating the extracurricular activities into the child care service, the parents’ geo-localization, the early departures and other functions, communication among the parties is significantly improved.</p>

        </div>
        <div class="taquets-slide" [class.active]="ref.selected === 2">

            <h2 class="section-title"><strong>Students’ records</strong></h2>
            <p>Keeping a logbook in the Pluriportail provides for a closer supervision of the students’ behaviour. Having the students’ health journal at hand helps the interveners to consult, among others, all the relevant information ensuring the children’s well-being, as well as allergies and medication.</p>

        </div>
        <div class="taquets-slide" [class.active]="ref.selected === 3">

            <h2 class="section-title"><strong>Finances</strong></h2>
            <p>Plurilogic knows how difficult it is to provide the child car service users with a flawless financial program. Integrated financial management, issuance of Revelé 24 and a reduced risk of possible errors in occasional payments are all advantages of which you can benefit with this module.</p>

        </div>
        
    </div>
</app-taquets>
<!-- end SECTION - taquets -->

<p>&nbsp;</p>
<p>&nbsp;</p>

<app-footer></app-footer>
